import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/Account`;;
function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
    if (value != undefined && value != null)
      stringparams = stringparams + key + "=" + value + "&";
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

const ApiAuth = {
  // login: (data) => {
  //   try{
  //   const url = `${baseServiceUrl}/requestAuthenticateByPhoneAsync`;
  //   var result = ServiceApi.post(url, data);
  //   catch (error) {
  //     alert(error.response.data.message);
  //   }
  //    return result
  // },
  // verifyMobile: (data) => {
  //   const url = `${baseServiceUrl}/authenticateByPhone`;
  //   var result = ServiceApi.post(url, data);
  //    return result
  // },
  login: (params) => {
    const url = `${baseServiceUrl}/authenticate`;
    return ServiceApi.post(url, params);
  },
  logout: (params) => {
    const url = `${baseServiceUrl}/logout` + paramsToStringList(params);
    return ServiceApi.post(url);
  },
  changePassword: (params) => {
    const url = `${baseServiceUrl}/changePassword`;
    return ServiceApi.post(url, params);
  },
  // register: (data) => {
  //   const url = `${baseServiceUrl}/register`;
  //   return ServiceApi.post(url, data);
  // },
};

export default ApiAuth;
